import { Modal, Form, Input, Select, message } from 'antd'
import { useEffect, useState } from 'react'
import '../index.less'
import service from '../../../../@services'
const { Option } = Select
const ShipNoModal = ({
  visible,
  record,
  close = () => {},
  storeCode,
  update = () => {}
}) => {
  const [form] = Form.useForm()
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [companiesOptions, setCompaniesOptions] = useState([])
  useEffect(() => {
    service.delivery.companiesList().then(res => {
      setCompaniesOptions(res)
    })
  }, [])
  //操作
  const onOk = async () => {
    try {
      await form.validateFields()
      setConfirmLoading(true)
      const deliveryCompany = form.getFieldValue('deliveryCompany')
      let companyNo = ''
      const index = companiesOptions.findIndex(
        item => item.deliveryCompany == deliveryCompany
      )
      if (index > -1) {
        companyNo = companiesOptions[index].companyNo
      }
      await service.delivery.updateDelivery({
        ...form.getFieldsValue(),
        ...{
          companyNo: companyNo,
          orderNo: record.orderNo,
          storeCode: storeCode.join('')
        }
      })
      await message.success('修改成功', 1)
      update('fix')
      setConfirmLoading(false)
    } catch (e) {
      console.log(e)
      setConfirmLoading(false)
    }
  }
  const onCancel = () => {
    //form.resetFields()
    form.setFieldsValue({
      deliveryCompany: record.deliveryCompany,
      deliveryCode: record.deliveryCode
    })
    if (close) {
      close()
    }
  }
  useEffect(() => {
    form.setFieldsValue({
      deliveryCompany: record.deliveryCompany,
      deliveryCode: record.deliveryCode
    })
  }, [record])
  return (
    <Modal
      className='ship-modal'
      title='修改单号'
      confirmLoading={confirmLoading}
      visible={visible}
      onCancel={onCancel}
      okText='保存'
      onOk={onOk}>
      <Form name='fixModal' form={form}>
        <Form.Item
          name='deliveryCompany'
          label='快递公司'
          rules={[{ required: true, message: '请选择快递公司' }]}>
          <Select
            placeholder='请选择快递公司'
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {companiesOptions.map((item, index) => (
              <Option key={index} value={item.deliveryCompany}>
                {item.deliveryCompany}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name='deliveryCode'
          label='物流单号'
          getValueFromEvent={event =>
            event.target.value.trim().replace(/[\u4E00-\u9FA5]/g, '')
          }
          rules={[{ required: true, message: '请选择物流单号' }]}>
          <Input allowClear placeholder='请输入物流单号' />
        </Form.Item>
      </Form>
    </Modal>
  )
}
export default ShipNoModal
